export const customStylesFinancialSummary = () => {
  return {
    headCells: {
      style: {
        backgroundColor: "#f3f4f6",
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        fontSize: "14px",
      },
    },
  };
};
